import React, { useEffect, useState } from 'react'
import Button from "reactstrap/es/Button"
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Select, message } from 'antd'
import '../../../assets/scss/views/_BulkCombineLabels.scss'
import { CombileLabelsShipByTiktokOrder } from '../../../services/api/apiNextBarcode'

function BulkCombineLabels(props) {
    const { resetBulkAll, reloadItems, closeMenu, items = [], selectedItems = [] } = { ...props }
    const [isOpen, setIsOpen] = useState(false)
    const [listItems, setListItems] = useState([])
    const [emails, setEmails] = useState([])
    const [loading, setLoading] = useState(false)

    const _genListItems = () => {
        const listItems = items.filter(item => selectedItems.includes(item._id))
        setListItems(listItems)
    }

    useEffect(() => {
        _genListItems()
    }, [items, selectedItems])

    const _handleToggleModal = () => {
        setIsOpen(!isOpen)
        if (isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    const handleChangeSelect = (field, value) => {
        if (field === 'emails') setEmails(value)
    }

    const handleCombileLabels = async () => {
        setLoading(true)
        const payload = {
            "receiver_email": emails,
            "orders": listItems.map(item => item.barcodeNumber),
            "force": true,
            "orders_per_file": 100,
            "fit_labels": false
        }
        try {
            const res = await CombileLabelsShipByTiktokOrder(payload)
            const { success, message: mess } = { ...res }
            if (!success) { throw new Error(mess) }
            message.success(`Gộp labels đơn shipbytiktok thành công.`)
            setIsOpen(false)
            resetBulkAll()
            closeMenu()
            reloadItems()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const barcodeOptions = items.length > 0 ? items.map((i) => ({ label: i.barcodeNumber, value: i.barcodeNumber })) : []
    const itemsNotShipByTiktok = listItems.filter((i) => i.shipping_plan !== 'shipbytiktok')

    return (
        <div className='BulkCombineLabels'>
            <Button color="link" onClick={_handleToggleModal} className="mr-1">Combine labels shipbytiktok order</Button>
            {isOpen && (
                <Modal isOpen={isOpen} className="BulkChangeStatus"
                >
                    <ModalHeader>
                        Gộp labels đơn shipbytiktok
                    </ModalHeader>
                    <ModalBody>
                        <div className="listItems mb-3">
                            <h6>Danh sách mã đơn:</h6>
                            <Select
                                className='barcode'
                                mode={'tags'}
                                options={barcodeOptions || []}
                                value={listItems.map(item => item.barcodeNumber)}
                                style={{ width: '100%' }}
                                placeholder='Danh sách mã đơn'
                                allowClear
                                disabled
                            />
                        </div>
                        <div className="emails mb-3">
                            <h6>Email:</h6>
                            <Select
                                className='email'
                                mode={'tags'}
                                value={emails || []}
                                style={{ width: '100%' }}
                                placeholder='Nhập email...'
                                allowClear
                                disabled={false}
                                tokenSeparators={[',', ' ']}
                                onChange={(value) => handleChangeSelect('emails', value)}
                                virtual={false}
                                open={false}
                            />
                        </div>
                        <div className="haveNotShipByTiktok">
                            {itemsNotShipByTiktok.length > 0 && itemsNotShipByTiktok.map((i) => (
                                <label className='text-danger'>
                                    {`Có đơn ${i.barcodeNumber} không phải shipbytiktok có muốn tiếp tục xử lý không?`}
                                </label>
                            ))
                            }
                        </div>
                        <h5 className='mb-0 mt-3 font-weight-bold'>Liên hệ với đội dev nếu sau 30 phút không nhận được email kết quả!</h5>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-sm-flex">
                            <Button
                                disabled={loading}
                                onClick={_handleToggleModal}
                                className="bg-grey ml-2"
                            >
                                Đóng
                            </Button>
                            <Button
                                disabled={loading || (!emails.length)}
                                onClick={handleCombileLabels}
                                className="bg-primary ml-2"
                            >
                                Gộp labels
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            )}
        </div>
    )
}

export default BulkCombineLabels